export default __webpack_public_path__ + "static/media/mimi_die_lesemaus.903fdfd3.jpg";